import { type InitFlowComponent } from '@capsicum/common';
import { useFavouriteTeamCheckerFlow } from '@capsicum/socios-core';

import { FavoriteTeamLoginCheckerFlow } from './FavoriteTeamLoginCheckerFlow';
import { FavouriteTeamRegistrationCheckerFlow } from './FavouriteTeamRegistrationCheckerFlow';

export const FavoriteTeamCheckerFlow: InitFlowComponent = ({ fallback, isReactive, next }) => {
	return useFavouriteTeamCheckerFlow({
		fallback,
		isReactive,
		LoginCheckerFlow: FavoriteTeamLoginCheckerFlow,
		next,
		RegistrationCheckerFlow: FavouriteTeamRegistrationCheckerFlow
	});
};

FavoriteTeamCheckerFlow.keepAlive = true;
